import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { adminReducer } from './admin/slice';
import { agentReducer } from './agent/slice';
import { bookingsReducer } from './bookings/slice';
import { buildingsReducer } from './buildings/slice';
import { desksReducer } from './desks/slice';
import { feedbackReducer } from './feedbacks/slice';
import { floorsReducer } from './floors/slice';
import { lastBookingsReducer } from './lastBookings/slice';
import { listenerMiddleware } from './listenerMiddleware';
import { messagesReducer } from './messages/slice';
import { navigationReducer } from './navigation/slice';
import { parkingReducer } from './parking/slice';
import { permissionsReducer } from './permissions/slice';
import { roomsReducer } from './rooms/slice';
import { searchReducer } from './search/slice';
import { sidesheetReducer } from './sidesheet/slice';
import { spacesReducer } from './spaces/slice';
import { townsReducer } from './towns/slice';
import { userReducer } from './user/slice';

export const store = configureStore({
  reducer: combineReducers({
    agent: agentReducer,
    admin: adminReducer,
    user: userReducer,
    desks: desksReducer,
    rooms: roomsReducer,
    parking: parkingReducer,
    sidesheet: sidesheetReducer,
    permissions: permissionsReducer,
    bookings: bookingsReducer,
    feedback: feedbackReducer,
    messages: messagesReducer,
    towns: townsReducer,
    buildings: buildingsReducer,
    floors: floorsReducer,
    spaces: spacesReducer,
    navigation: navigationReducer,
    lastBookings: lastBookingsReducer,
    search: searchReducer,
  }),
  devTools: true,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          'desks.excludedDates',
          'desks.dates',
          'desks.staticObjects',
          'desks.bookingObjects',
          'rooms.bookingObjects',
          'rooms.staticObjects',
          'parking.bookingObjects',
          'user.data.permissions',
          'user.data.spaces',
          'user.data.adminSpaces',
          'admin.bookingObjects',
          'towns.towns',
          'buildings.currentRequests',
          'buildings.buildingsById',
          'buildings.buildingsByTowns',
          'floors.currentRequests',
          'floors.floorsByBuilding',
          'floors.floorsById',
          'bookings.now',
          'search.now',
          'spaces.bookingObjects',
          'spaces.removings',
          'spaces.relatedSpaces',
        ],
        ignoredActions: [
          'desks/fetchDesks/fulfilled',
          'desks/setDates',
          'rooms/fetchRooms/fulfilled',
          'parking/fetchParkingPlaces/fulfilled',
          'floors/fetchFloors/fulfilled',
          'towns/fetchTowns/fulfilled',
          'buildings/fetchBuildings/fulfilled',
          'bookings/fetchBookings/fulfilled',
          'desks/fetchExcludedDates/fulfilled',
          'spaces/fetchSpaceMapData/fulfilled',
          'admin/fetchAdminAllData/fulfilled',
          'admin/fetchBookingObjects/fulfilled',
        ],
      },
    }).prepend(listenerMiddleware.middleware),
});
